import Ammo from "ammojs-typed";
class MeshShapeController {
    /**
     * Create a convex hull shape based on the given geometry.
     * Reference:
     * https://stackoverflow.com/q/59665854/8802590
     * @param geometry the buffer geometry to create a shape from.
     * @param margin The amount of margin that the shape should keep from other objects.
     * @returns the created shape.
     */
    createShape(geometry, margin) {
        const mesh = new Ammo.btTriangleMesh(true, true);
        const vertices = geometry.attributes.position.array;
        const indices = geometry.getIndex()?.array;
        if (indices) {
            for (let i = 0; i * 3 < indices.length; i++) {
                mesh.addTriangle(new Ammo.btVector3(vertices[indices[i * 3] * 3], vertices[indices[i * 3] * 3 + 1], vertices[indices[i * 3] * 3 + 2]), new Ammo.btVector3(vertices[indices[i * 3 + 1] * 3], vertices[indices[i * 3 + 1] * 3 + 1], vertices[indices[i * 3 + 1] * 3 + 2]), new Ammo.btVector3(vertices[indices[i * 3 + 2] * 3], vertices[indices[i * 3 + 2] * 3 + 1], vertices[indices[i * 3 + 2] * 3 + 2]), false);
            }
        }
        else {
            for (let i = 0; i < vertices.length; i += 9) {
                mesh.addTriangle(new Ammo.btVector3(vertices[i], vertices[i + 1], vertices[i + 2]), new Ammo.btVector3(vertices[i + 3], vertices[i + 4], vertices[i + 5]), new Ammo.btVector3(vertices[i + 6], vertices[i + 7], vertices[i + 8]), false);
            }
        }
        const shape = new Ammo.btBvhTriangleMeshShape(mesh, true, true);
        shape.setMargin(margin);
        return shape;
    }
}
export { MeshShapeController };
